import ArticlePropsService from "@core-ui/ContextServices/ArticleProps";
import ResourceService from "@core-ui/ContextServices/ResourceService/ResourceService";
import t from "@ext/localization/locale/translate";
import { saveGalleryImages } from "@ext/markdown/elements/gallery/edit/logic/createGallery";
import type { Editor } from "@tiptap/core";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";
import { type ChangeEvent, useRef } from "react";

interface GalleryAddImagesButtonProps {
	editor: Editor;
	getPos: () => number | undefined;
}

const GalleryAddImagesButton = ({ editor, getPos }: GalleryAddImagesButtonProps) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const fileName = ArticlePropsService.value?.fileName;
	const resourceService = ResourceService.value;
	const label = t("editor.gallery.add");

	const onChange = async (event: ChangeEvent<HTMLInputElement>) => {
		const files = [...event.currentTarget.files];
		event.currentTarget.value = "";
		const content = await saveGalleryImages(files, fileName, resourceService);
		if (!content.length || !editor || editor.isDestroyed) return;
		const pos = getPos();
		const gallery = typeof pos === "number" ? editor.state.doc.nodeAt(pos) : null;
		if (gallery?.type.name !== "gallery") return;
		editor.commands.insertContentAt(pos + gallery.nodeSize - 1, content);
	};

	return (
		<>
			<GlassToolbarButton aria-label={label} onClick={() => inputRef.current?.click()} tooltipText={label}>
				<GlassToolbarIcon icon="image-plus" />
			</GlassToolbarButton>
			<input accept="image/*" hidden multiple onChange={onChange} ref={inputRef} type="file" />
		</>
	);
};

export default GalleryAddImagesButton;
